import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, Quote as QuoteIcon } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="testimonials-page">
      <Seo
        title="Client Reviews & Testimonials | K.O Chef & Catering Southwest Florida"
        description="Read what our clients say about K.O CHEF & CATERING — trusted for weddings, corporate events and private dining across Naples, Bonita Springs and Fort Myers, FL."
        path="/testimonials"
      />
      <PageHero overline="Testimonials" title="Words From Our Guests"
        subtitle="The greatest compliment is a table full of smiles."
        image="https://images.unsplash.com/photo-1649615644613-758b850399c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" />
      <section className="py-20 md:py-28">
        <div className="container-lux grid grid-cols-1 md:grid-cols-2 gap-6">
          {items.map((r, i) => (
            <Reveal key={r.id} delay={(i % 2) * 0.1}>
              <div className="border border-white/10 p-8 h-full flex flex-col" data-testid={`testimonial-${i}`}>
                <div className="flex items-center justify-between mb-5">
                  <QuoteIcon className="w-8 h-8 text-gold/40" />
                  <div className="flex gap-1">{Array.from({length:r.rating}).map((_,k)=><Star key={k} className="w-4 h-4 fill-gold text-gold" />)}</div>
                </div>
                <p className="text-white/75 leading-relaxed italic font-serif text-lg">"{r.text}"</p>
                <div className="flex items-center gap-4 mt-6 pt-6 border-t border-white/10">
                  <img src={r.photo} alt={r.name} className="w-12 h-12 rounded-full object-cover" />
                  <div><p className="text-white">{r.name}</p><p className="text-white/40 text-sm">{r.role}</p></div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="container-lux text-center mt-16">
          <Link to="/request-a-quote" className="btn-gold" data-testid="testimonials-cta">Start Your Experience</Link>
        </div>
      </section>
    </div>
  );
}
